import PropTypes from 'prop-types';
import Head from 'next/head';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import { getFaqMicrodata } from 'utils/microdata/utils';
import { REVEAL_ANIMATION_PROPS } from 'utils/constants';
import styles from './styles.module.scss';
import Animated from '../Animated';

const CollapseItem = dynamic(() => import('UI/components/CollapseItem'));

const FAQ = ({ type, faqList, isArticalPage }) => (
  <>
    <Head>
      {/* Somehow microdata doesnt work with next/script so use this instead */}
      <script
        id="JSON-LD-faq"
        key="JSON-LD-faq"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getFaqMicrodata({ faqList }), null, 2) }}
      />
    </Head>

    <Animated
      {...REVEAL_ANIMATION_PROPS}
      transitionDelay={50}
    >
      <div className={cn(styles.frequentlyAskedQuestions, styles[type], { [styles.faqArticalPage]: isArticalPage })}>
        {faqList.map((faq) => (
          <CollapseItem
            key={`faq-item/${faq.question}`}
            type={type}
            faq={faq}
          />
        ))}
      </div>
    </Animated>
  </>
);

FAQ.defaultProps = {
  faqList: [],
  isArticalPage: false,
};

FAQ.propTypes = {
  faqList: PropTypes.instanceOf(Array),
  isArticalPage: PropTypes.bool,
};

export default FAQ;
